var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImportPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_1706)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 15,
    height: 15,
    fill: "#2B2F32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.17706 0 0 7.17775 0 16C0 24.8223 7.17706 32 16 32C24.8229 32 32 24.8223 32 16C32 7.17775 24.8229 0 16 0ZM22.3607 16.5606L13.0274 22.5606C12.918 22.6315 12.7917 22.6667 12.6667 22.6667C12.5573 22.6667 12.4466 22.6393 12.3477 22.5853C12.1328 22.4681 12 22.2441 12 22V10C12 9.75587 12.1328 9.53187 12.3477 9.41469C12.5586 9.29881 12.8229 9.30594 13.0274 9.43944L22.3607 15.4394C22.5508 15.5618 22.6667 15.7734 22.6667 16C22.6667 16.2266 22.5508 16.4381 22.3607 16.5606Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_1706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportPreview);
export default __webpack_public_path__ + "static/media/ICON_IMPORT_PREVIEW.44d99adf7758d732665b2da2ac06c408.svg";
export { ForwardRef as ReactComponent };